import React, { useCallback, useContext } from "react";
import { UI } from "@wwimmo/ui";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import { Invoice } from "src/stores/krediflow/InvoiceStore";
import { getInvoiceTypeIcon } from "src/screens/creditors/Creditors";
import { formatCurrency } from "src/utils/Currency";
import { RootStoreContext } from "src/stores/RootStore";
import * as Sentry from "@sentry/react";
import { observer } from "mobx-react-lite";
import styles from "./InvoiceListRow.module.css";
import listStyles from "./InvoiceList.module.css";

const InvoiceListRowMobileBase = (props: { invoice: Invoice }) => {
    const { number, date, invoiceType, realestate, assignedUser, creditor, amount } = props.invoice;

    const { invoiceListStore } = useContext(RootStoreContext);

    const { t } = useTranslation();

    // OnChange method needed for controlled checkbox component - all the logic is in the onClickCheckbox method because only from there the stopPropagation works (preventing row click event)
    const onChangeDummyMethod = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {}, []);

    const onClickCheckbox = useCallback(
        (e: React.MouseEvent<HTMLInputElement>) => {
            e.stopPropagation(); // Prevent row click event

            if (number) {
                invoiceListStore.handleBatchProcessCheckboxClick(number);
            }
        },
        [number, invoiceListStore]
    );

    return (
        <UI.List.Row className={styles.InvoiceListRowMobile} key={`row-mobile-${number}`}>
            <div className={styles.MobileTop}>
                <div className={styles.CheckboxMobile}>
                    <input
                        type="checkbox"
                        className={listStyles.BatchProcessCheckbox}
                        onChange={onChangeDummyMethod}
                        onClick={onClickCheckbox}
                        checked={number ? invoiceListStore.batchProcessMap[number] : false}
                    />
                </div>
                <div className={styles.TypeIconMobile}>
                    <img
                        src={getInvoiceTypeIcon(invoiceType)}
                        alt={t(`screens.kredi_flow.invoice_type.${String(invoiceType)}`) ?? "icon"}
                    />
                </div>
                <div className={styles.MobileLeft}>
                    <div>
                        <strong>
                            {number} -{" "}
                            {creditor?.name
                                ? creditor?.name
                                : t(`screens.kredi_flow.invoice_type.${String(invoiceType)}`)}
                        </strong>
                    </div>
                </div>
                <div className={styles.MobileRight}>
                    <div>{amount ? formatCurrency(amount) : "-"}</div>
                </div>
            </div>
            <div className={styles.MobileBottom}>
                <div className={styles.CheckboxMobile}></div>
                {assignedUser && (
                    <div className={styles.Avatar}>{`${assignedUser.name1.charAt(0)}${
                        assignedUser.name2?.charAt(0) ?? ""
                    }`}</div>
                )}
                <div className={styles.MobileLeft}>
                    {realestate && (
                        <div>
                            <div>{realestate.name}</div>
                            <div>
                                {realestate.zip} {realestate.city}
                            </div>
                        </div>
                    )}
                </div>
                <div className={styles.MobileRight}>{date && format(new Date(date), "dd.MM.yy")}</div>
            </div>
        </UI.List.Row>
    );
};

export const InvoiceListRowMobile = Sentry.withProfiler(observer(InvoiceListRowMobileBase));
